<template>
    <az-container class="reavaliacaoListagemTabela">
        <az-form>
            <v-data-table
                :headers="colunas"
                :items="itens"
                ref="itemTabela"
                :loading="false"
                :options.sync="paginacaoInterna"
                :server-items-length="totalItens"
                @click:row="tratarClick"
                class="az-table-list az-table-list-access tabela-patrimonio"
                hide-default-footer
                disable-sort
                no-data-text="Não há reavaliações cadastradas">
                <template v-slot:item.codigo="{item}" style="max-width: 300vw;">
                    {{$options.filters.retornaCodigoOuNumero(item.id,item.numero)}}
                </template>
                <template v-slot:item.orgao="{item}">
                    <span class="d-inline-block text-truncate" style="max-width: 30vw;">
                        {{item.orgao | textoSemValor}}
                    </span>
                </template>
                <template v-slot:item.contaContabil="{item}">
                    <span class="d-inline-block text-truncate" style="max-width: 30vw;">
                        {{item.contaContabil.descricao | textoSemValor}}
                    </span>
                </template>
                <template v-slot:item.ano="{item}">
                    {{item.ano}}
                </template>
                <template v-slot:item.situacao="{ item }">
                    <v-icon
                        class="mr-1"
                        color="secondary"
                        size="13"
                        v-if="item.situacao === 'EM_ELABORACAO'">
                        fas fa-edit
                    </v-icon>
                    {{ item.situacao | azEnum(situacoesReavaliacao) }}
                </template>
                <template v-slot:item.colunaEscondida="{  }">
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span class="mobile">Acessar</span>
                </template>
            </v-data-table>

            <div class="az-pagination">
                <v-pagination
                    v-if="paginas > 1"
                    v-model="paginacaoInterna.page"
                    :length="paginas"
                    next-icon="fas fa-chevron-right"
                    prev-icon="fas fa-chevron-left"/>

                <v-spacer v-if="paginas <= 1"/>

                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" @change="resetaPage" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
    import {mutationTypes, situacoesReavaliacao} from '@/core/constants'

    export default {
        name: 'ReavaliacaoListagemTabela',
        props: {
            itens: {
                required: true,
                type: Array,
                default: () => {
                    return []
                }
            },
            paginacao: {
                required: true,
                type: Object
            },
            paginas: {
                required: true,
                type: Number
            },
            totalItens: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                colunas: [
                    {
                        text: 'Código',
                        value: 'codigo',
                        sortable: true,
                        align: 'left',
                        width: '10%',
                        class: 'black--text'
                    },
                    {
                        text:'Órgão',
                        value:'orgao',
                        sortable:true,
                        align:'left',
                        width:'10%',
                        class:'black--text'
                    },
                    {
                        text: 'Conta Contábil',
                        value: 'contaContabil',
                        sortable: true,
                        align: 'left',
                        width: '10%',
                        class: 'black--text'
                    },
                    {
                        text: 'Ano',
                        value: 'ano',
                        sortable: true,
                        align: 'left',
                        width: '10%',
                        class: 'black--text'
                    },
                    {
                        text: 'Situação',
                        value: 'situacao',
                        sortable: true,
                        align: 'left',
                        width: '15%',
                        class: 'black--text'
                    },
                    {
                        text: '',
                        value: 'colunaEscondida',
                        sortable: false,
                        align: 'center',
                        width: '10%',
                        class: 'black--text'
                    },
                ],
                paginacaoInterna: this.paginacao,
                linhasPorPagina: [10, 25, 50, 100]
            }
        },
        computed: {
            situacoesReavaliacao() {
                return situacoesReavaliacao
            }
        },
        watch: {
            paginacaoInterna: {
                handler(novoValor) {
                    this.$emit('paginar', novoValor)
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            resetaPage() {
                this.$store.commit(mutationTypes.PATRIMONIO.RESETA_PAGE)
            },
            tratarClick(item) {
                this.$emit('acessar', item)
            },
            tratarFiltro() {
                this.$emit('filtrarPorTipo', this.tipoPatrimonio)
            }
        },
        filters: {
            retornaCodigoOuNumero(codigo, numero) {
                if (numero) {
                    return numero
                }
                return codigo
            }
        }
    }
</script>

<style lang="stylus">
    .reavaliacaoListagemTabela
        .az-table-list tbody tr
            cursor pointer !important

        .tabela-patrimonio
            min-height 62vh !important

            tbody td
                padding 10px !important

    @media (max-width: 720px)
        .tabela-patrimonio
            .mobile
                display inline-block
                margin-left 3px

        .v-data-table__mobile-table-row
            cursor pointer !important

</style>
